import * as React from 'react';
import { memo } from 'react';

import { generateClassNameString } from 'helper/css';
import noop from 'helper/noop';

import Icon from 'components/atoms/Icon';

type RecipeTooltipProps = {
	modifier?: string | string[];
	visible: boolean;
	text: string;
	onClose: Function;
};

const RecipeTooltip = ({ modifier, text, visible = false, onClose = noop }: RecipeTooltipProps) => (
	<div
		className={
			generateClassNameString('m-recipe-tooltip', modifier) + (visible ? ' state-m-recipe-tooltip--visible' : '')
		}
	>
		<span className="m-recipe-tooltip__arrow" />
		<div className="m-recipe-tooltip__close js-ui-m-recipe-tooltip__close" onClick={() => onClose()}>
			<button className="a-knob a-knob--filled-green-light a-knob--s" aria-label="Close (Press escape to close)">
				{/* Use img tag instead of pattern to fix IE11 bug <img src="/assets/img/svg/close.svg" alt=""> */}
				{/*<img src="/assets/img/svg/close.svg" alt="x" />*/}
				<Icon iconName="close" />
			</button>
		</div>
		<p className="m-recipe-tooltip__text">{text}</p>
	</div>
);

export default memo(RecipeTooltip, (prevProps, nextProps) => {
	return prevProps.text === nextProps.text && prevProps.visible === nextProps.visible;
});
